module.exports = __webpack_public_path__ + "img/IMG_2545.29b5fece.png";